import { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { AuthContext } from "contexts/AuthContext";

const DukeOAuthCallbackHandler = () => {
  const { setToken } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const code = new URLSearchParams(location.search).get("code");
    if (!code) return navigate("/login");

    axios
      .post("/api/loginWithTenDuke", { code })
      .then(async (response) => {
        const { token } = response.data;

        // Save token to localStorage or cookie (optional)
        localStorage.setItem("auth_token", token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        // setCookie("userToken", response.data.token);
        // setCookie("cleverAccessToken", response.data.cleverAccessToken);
        setToken(token);

        navigate("/");
      })
      .catch((error) => {
        console.log(error);
        if (error.response.data.dukeAccessToken) {
          // setCookie("dukeAccessToken", error.response.data.dukeAccessToken);
        }
        console.error("10Duke login failed", error);
        // setError("You do not have access. Please contact your school administrator.");
        window.location.assign("/login");
      });
  }, [location.search, navigate, setToken]);

  return <div>Signing you in...</div>;
};

export default DukeOAuthCallbackHandler;
